// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pCtp","clinicsSelect":"styles_clinicsSelect__4iDUE"};